import React from 'react';
import './Techs.css';

import Tilt from 'react-tilt';

import { AnimationOnScroll } from 'react-animation-on-scroll';
import "animate.css/animate.min.css";

const Techs = () => {
    return(
        <div className="techs">
            <AnimationOnScroll animateIn="animate__bounceIn" className="techs-grid">
                <Tilt className="techs-card">
                    <img src="./assets/images/html-5.png" alt="icon" />
                    <h3>Html 5</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/css-3.png" alt="icon" />
                    <h3>Css 3</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/javascript.png" alt="icon" />
                    <h3>JavaScript</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/typescript.png" alt="icon" />
                    <h3>TypeScript</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/angular-js-icon.png" alt="icon" />
                    <h3>Angular 2+</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/react.png" alt="icon" />
                    <h3>React</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/php.png" alt="icon" />
                    <h3>Php</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/java.png" alt="icon" />
                    <h3>Java</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/hashtag.png" alt="icon" />
                    <h3>C#</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/git.png" alt="icon" />
                    <h3>Git</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/visual-studio.png" alt="icon" />
                    <h3>Visual studio code</h3>
                </Tilt>
                <Tilt className="techs-card">
                    <img src="./assets/images/figma.png" alt="icon" />
                    <h3>Figma</h3>
                </Tilt>
            </AnimationOnScroll>
        </div>
    );
}

export default Techs;